module.exports = __webpack_public_path__ + "img/male.c19ec3ed.png";